import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root',
})
export class OutletService extends ApiService {
    constructor(protected http: HttpClient) {
        super(http);
    }

    getOutlets(query?: any) {
        const params = this.serializeParams(query);
        return this.post(this.generalUrl, `general/hrc/outlets?${params}`);
    }

    getCityOutlets(query) {
        const data = {
            api_call: `/general/hrc/outlets?city=${query.city}&radius=20&latitude=${query.latitude}&longitude=${query.longitude}&page=1&per_page=25`,
            method: 'GET',
        };
        return this.http.post(this.generalUrl, data, { withCredentials: true });
    }

    getAllDetailsBySlug(slug) {
        return this.post(this.generalUrl, `general/hrc/outlets/${slug}?radius=20&lat=28.56321&lng=77.456`);
    }

    getBannerImages(hrcId) {
        return this.post(this.generalUrl, `hrc/${hrcId}/images`);
    }

    getAllDetailsById(id) {
        const data = {
            api_call: `/general/hrc/outlets/${id}`,
            method: 'GET',
        };
        return this.http.post(this.generalUrl, data, { withCredentials: true });
    }

    getStoriesBySlug(slug) {
        return this.post(this.generalUrl, `general/hrc/outlets/${slug}/coffee-stories`);
    }

    getStoriesByID(id) {
        const data = {
            api_call: `/general/hrc/outlets/${id}/coffee-stories`,
            method: 'GET',
        };

        return this.http.post(this.generalUrl, data, { withCredentials: true });
    }
    getDataSortBy(cityname, sortBy) {
        const data = {
            api_call: `/general/hrc/outlets?city=${cityname}&sort_by=${sortBy}`,
            method: 'GET',
        };
        return this.http.post(this.generalUrl, data, { withCredentials: true });
    }
    getDataSortByRadius(cityname, lat, lng) {
        const data = {
            api_call: `/general/hrc/outlets?city=${cityname}&sort_by=radius&latitude=${lat}&longitude=${lng}`,
            method: 'GET',
        };
        return this.http.post(this.generalUrl, data, { withCredentials: true });
    }
    getDataFilter(cityname, rating) {
        const data = {
            api_call: `/general/hrc/outlets?city=${cityname}&rating=${rating}`,
            method: 'GET',
        };
        return this.http.post(this.generalUrl, data, { withCredentials: true });
    }
    getCityOutletPerPage(cityname, page, perPageList) {
        const data = {
            api_call: `/general/hrc/outlets?city=${cityname}`,
            method: 'GET',
        };
        return this.http.post(this.generalUrl, data, { withCredentials: true });
    }
    getOutletsByQrScan(lat, lng) {
        const data = {
            api_call: `/general/hrc/outlets?sort_by=radius&latitude=${lat}&longitude=${lng}&source=qr-scan`,
            method: 'GET',
        };
        return this.http.post(this.generalUrl, data, { withCredentials: true });
    }
    getNearbyOutlets(lat, lng) {
        const data = {
            api_call: `/general/hrc/outlets?sort_by=radius&latitude=${lat}&longitude=${lng}`,
            method: 'GET',
        };
        return this.http.post(this.generalUrl, data, { withCredentials: true });
    }
}
